/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'logs-signpost';
const prefix = `${moduleName}.${componentName}`;

export const defaultErrorMsgLabel = `${prefix}.defaultErrorMsgLabel`;
export const reloadPageLabel = `${prefix}.reloadPageLabel`;
export const emptyDataMessageLabel = `${prefix}.emptyDataMessageLabel`;
export const timeoutMessageLabel = `${prefix}.timeoutMessageLabel`;

export const ENGLISH = {
    [defaultErrorMsgLabel]: 'An error occurred while loading the signpost logs, please try again.',
    [reloadPageLabel]: 'Reload Page',
    [emptyDataMessageLabel]: 'No Data Available',
    [timeoutMessageLabel]: 'We were unable to fetch all the logs. Please reduce the timeframe or refresh logs.',
};
